<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
      width="450"
    >
      <v-sheet>
        <v-container>
          <v-subheader>Nueva venta</v-subheader>
          <date-input
            v-model="fecha"
            label="Fecha"
            max-today
          ></date-input>
          <v-text-field
            v-model="cliente"
            label="Cliente"
            prepend-icon="mdi-account"
            color="primary"
          ></v-text-field>
          <v-divider class="my-2"></v-divider>
          <v-select
            v-model="producto"
            :items="productos"
            label="Producto"
            prepend-icon="mdi-text"
            color="primary"
          ></v-select>
          <v-text-field
            v-model="cantidad"
            label="Cantidad"
            prepend-icon="mdi-counter"
            color="primary"
          ></v-text-field>
          <v-text-field
            v-model="monto"
            label="Monto"
            prepend-icon="mdi-currency-usd"
            color="primary"
          ></v-text-field>
          <v-btn
            color="primary"
            block
          >
            Agregar
          </v-btn>
          <v-divider class="my-2"></v-divider>
          <v-footer>
            <v-btn
              :disabled="$can('debitos.store')"
              color="primary"
              @click="onSubmit"
              :loading="loading"
              block
            >
              Registrar
            </v-btn>
          </v-footer>
        </v-container>
      </v-sheet>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import PrecioMixin from '@/mixins/Precios';
import DateInput from '@/components/DateInput'
export default {
  name: 'ConsumidorFinalCreateComponent',
  mixins: [PrecioMixin],
  components: {
    'date-input': DateInput,
  },
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    selected: Boolean,
  },
  data () {
    return {
      drawer: true,
      valid: false,
      precio: 0,
      monto: 0,
      productos: ['GARRAFA 10KG + CARGA', 'CILINDRO 45KG + CARGA', 'CARGA MICROGARRAFA', 'CARGA GARRAFA 10KG', 'CARGA CILINDRO 45KG'],
      producto: null,
    }
  },
  beforeDestroy () {
    // Remueve el event listener en el gancho beforeDestroy
    window.removeEventListener('keydown', this.handleKeyboard);
    this.$root.$off('update:appbarnav', this.onUpdateAppNavBar);
    this.onLimpiar()
  },
  created () {
    this.$root.$on('update:appbarnav', this.onUpdateAppNavBar);
    this.onLimpiar()
  },
  computed: {
    ...mapGetters('ConsumidorFinal', ['edited', 'rules', 'loading']),
    fecha: {
      get () {
        return this.edited.fecha
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          fecha: value
        })
      }
    },
    detalle: {
      get () {
        return this.edited.detalle
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          detalle: value
        })
      }
    },
    cliente: {
      get () {
        return this.edited.cliente
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          cliente: value
        })
      }
    },
    cantidad: {
      get () {
        return this.edited.cantidad
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          cantidad: value
        })
      }
    },
    total: {
      get () {
        return this.edited.total
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          total: value
        })
      }
    },
  },
  watch: {
    cantidad (newVal) {
      this.total = this.precio * newVal
    },
  },
  methods: {
    // ...mapActions('Transacciones', ['onFetch']),
    ...mapActions('ConsumidorFinal', ['onSave', 'onClearEdited', 'onClearSelected']),
    ...mapMutations('ConsumidorFinal', ['setEdited']),
    async onLimpiar () {
      this.onClearEdited()
      this.onClearSelected()
      this.fecha = await this.$moment().format('YYYY-MM-DD');
    },
    onSubmit(event) {
      event.preventDefault();
      // Si ya estamos enviando, salimos de la función
      if (this.isSubmitting || !this.fecha) {
        return;
      }
      this.isSubmitting = true; // Establecer la bandera en true

      this.onSave().then(response => {
        this.$store.dispatch('ConsumidorFinal/onFetch');
        this.onLimpiar();
      })
      .finally(() => {
        this.isSubmitting = false; // Restablecer la bandera a false al finalizar
      });
    },
    handleKeyboard(event) {
      if(event.key === 'Enter' && !event.ctrlKey) {
        this.onSubmit(event)
      }
    },
    onUpdateAppNavBar() {
      this.drawer = !this.drawer
    },
    onCoeficiente(newVal) {
      this.total = this.cantidad * this.precio;
    }
  },
}
</script>
